module.exports = __webpack_public_path__ + "static/media/ips.566820f8.svg";